module.exports = __webpack_public_path__ + "img/banner-bg.3eedc8b3.jpg";